import { factory, getResponseCamelization } from '@repo-level/core-front';
import type { CMSApiBase, CMSGroupMode, CMSImageBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';
import type { IMinDepV2 } from './bonuses';

export interface IBonus extends CMSApiBase {
  offerTitle: string;
  itemImg: CMSImageBase;
  minDeps: IMinDepV2[];
  specialNote: string;
  code: string;
}

export const getWpBonusesCMSUrl = factory(
  (r) => (lang: string) =>
    r<IWpBonusGroup[]>(
      'get',
      buildCmsUrl({
        path: 'wp-bonuses',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export interface IWpBonusGroup {
  id: number;
  bonuses: IBonus[];
  groupsInclude: string | null;
  groupsExclude: string | null;
  groupsIncludeMode: CMSGroupMode;
  groupsExcludeMode: CMSGroupMode;
}
